// Rutas del módulo Clientes (panel interno).
export default [
  {
    path: 'crear',
    name: 'clientes-crear',
    component: () => import(/* webpackChunkName: "clientes" */ '@/apps/clientes/pages/CrearClientePage.vue'),
  },
]
